<template>
  <div class="layout-head-nav" :class="{ border: activeMenu.code != 'home' }">
    <div class="nav-list flex def-w">
      <div
        class="nav-item"
        :class="{ active: activeMenu.code == item.code }"
        v-for="item in menus"
        :key="item.code"
      >
        <div
          class="item"
          v-if="!showSubMenu(item)"
          @click="handleMenuClick(item)"
        >
          {{ item.name }}
        </div>
        <el-dropdown placement="bottom" v-else>
          <span class="el-dropdown-link">
            {{ item.name }}
          </span>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="it in item.appColumnRespVOList"
              :key="it.code"
              @click.native="handleMenuClick(it)"
            >
              {{ it.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Message } from "element-ui";
import { buildAuthUrl } from "@/utils/common";

export default {
  name: "HeadNav",
  components: {},
  props: {},
  data() {
    return {};
  },

  computed: {
    ...mapGetters(["menus", "activeMenu", "isLogin", "userInfo"]),
  },
  created() {},
  mounted() {},
  methods: {
    showSubMenu(menu) {
      if (menu.appColumnRespVOList && menu.appColumnRespVOList.length) {
        return menu.appColumnRespVOList.some((item) => item.visible);
      }
      return false;
    },
    handleMenuClick(item) {
      if (item.target) {
        return window.open(item.path);
      }

      if (item.code == "nb" || item.code == "nbtp") {
        if (!this.isLogin) {
          Message({
            message: "请登录后查看",
            duration: 2 * 1000,
          });
          setTimeout(() => {
            window.open(buildAuthUrl(process.env.VUE_APP_LOGIN_URL));
          }, 1000);
          return;
        }
        if (!this.userInfo.isNb) {
          Message({
            message: "您非中化集团内部单位，无权限进入！",
            duration: 2 * 1000,
          });
          return;
        }
      }

      // 点击帮助中心或关于我们时，自动跳转到第一个子菜单
      if (item.code === "bzzx" || item.code === "gywm") {
        // 获取所有菜单树
        const allMenusTree = this.$store.state.permission.allMenusTree;
        // 找到当前菜单
        const currentMenu = allMenusTree.find(
          (menu) => menu.code === item.code,
        );
        if (
          currentMenu &&
          currentMenu.children &&
          currentMenu.children.length > 0
        ) {
          // 跳转到第一个子菜单
          const firstChild = currentMenu.children[0];
          this.$router.push(firstChild.path);
          return;
        }
      }

      this.$router.push(item.path);
      this.$store.dispatch("permission/changeActiveMenu", item);
    },
  },
};
</script>

<style scoped lang="scss">
.layout-head-nav {
  width: 100%;
  background-color: #fff;

  &.border {
    border-bottom: 2px solid $--color-primary;
  }

  .nav-item {
    height: 60px;
    line-height: 60px;
    margin-right: 45px;
    position: relative;
    cursor: pointer;

    &.active::after {
      content: "";
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 6px;
      background-color: $--color-primary;
    }

    .item {
      height: 100%;
      color: #333;
      font-size: 16px;
    }

    &:hover {
      .item {
        color: $--color-primary;
      }
    }

    .el-dropdown-link {
      font-size: 16px;
    }
  }
}
</style>
